import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { CompteursAbsenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/CompteursAbsenceDto";
import VerticalScroll from "../../../../../shared/components/VerticalScroll/vertical-scroll";
import { KeyValue } from "../../../../calendrier/calendrier.model";
import { CounterSort } from "./situationManager.model";

@Component({
	filters: {
		ucFirst(value: string): any {
			value = value.toLowerCase();

			return (value) ? value.charAt(0).toUpperCase() + value.slice(1) : "";
		},
		uppercase(value: string): any {
			return (value) ? value.toUpperCase() : "";
		}
	}
})
export default class SituationManager extends Vue {
	public curentOrderColumn = "NomSalarie";
	public orderingAsc = true;
	public dataFiltred: CompteursAbsenceDto[] = [];

	@Prop()
	public dataReady = false;

	@Prop()
	public isModeManager;

	@Prop()
	public anneeCouranteConges = new Date().getFullYear();

	@Prop()
	public listeCompteursAbsencesEquipe?: CompteursAbsenceDto[] = [];

	public counterSort = CounterSort;

	public listSortDisplay: KeyValue[] = [
		{
			key: this.counterSort.CurrentYear,
			value: ""
		},
		{
			key: this.counterSort.NextYear,
			value: ""
		},
		{
			key: this.counterSort.RTT,
			value: "RTT"
		}
	];

	public currentSort = this.counterSort.CurrentYear;

	@Watch("listeCompteursAbsencesEquipe")
	public organize(): void {
		this.orderBy(this.curentOrderColumn);
	}

	public mounted(): void {
		this.listSortDisplay[0].value = "CP " + (this.anneeCouranteConges - 1) + " / " + (this.anneeCouranteConges);
		this.listSortDisplay[1].value = "CP " + (this.anneeCouranteConges) + " / " + (this.anneeCouranteConges + 1);
	}

	public randomAvatarColor(): any {
		const backgroundColor = this.randomHexaColor();
		const textColor = (this.backgroundIsTooDark(backgroundColor)) ? "rgb(255, 255, 255)" : "rgb(0, 0, 0)";

		return {
			backgroundColor: backgroundColor,
			color: textColor
		};
	}

	private backgroundIsTooDark(hexa: string): boolean | void {
		const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexa);

		if (result == null) {
			return;
		}

		let r = parseInt(result[1], 16);
		let g = parseInt(result[2], 16);
		let b = parseInt(result[3], 16);

		r /= 255;
		g /= 255;
		b /= 255;

		const light = (Math.max(r, g, b) + Math.min(r, g, b)) / 2;

		return light < 0.65;
	}

	private randomHexaColor(): string {
		const n = (Math.random() * 0xfffff * 1000000).toString(16);

		return "#" + n.slice(0, 6);
	}

	public getFullnameNormalised(nom: string, prenom: string): string | void {
		if (this.$options.filters != undefined) {
			return this.$options.filters.uppercase(nom) + " " + this.$options.filters.ucFirst(prenom);
		}
	}

	public orderBy(columnName: string): void {
		if (this.curentOrderColumn == columnName) {
			this.orderingAsc = !this.orderingAsc;
		} else {
			this.orderingAsc = true;
		}
		this.curentOrderColumn = columnName;
		this.doOrder();
	}

	private doOrder(): void {
		const orderingAsc = this.orderingAsc;
		const columnName = this.curentOrderColumn;
		if (this.listeCompteursAbsencesEquipe != undefined) {
			this.listeCompteursAbsencesEquipe = this.listeCompteursAbsencesEquipe.sort(function(a: CompteursAbsenceDto, b: CompteursAbsenceDto) {
				if (a[columnName] < b[columnName]) {
					return (orderingAsc ? -1 : 1);
				}
				if (a[columnName] > b[columnName]) {
					return (orderingAsc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	@Watch("isModeManager")
	private refreshScroll(): void {
		const scrollCompteur = this.$refs.scrollCompteur as VerticalScroll;
		scrollCompteur.refresh();

		const scrollCompteurMini = this.$refs.scrollCompteurMini as VerticalScroll;
		scrollCompteurMini.refresh();
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/situationDesAbsences/tableaux/situationManager/situationManager.ts